"use client"

import { useEffect } from 'react'

/**
 * MetricsHydrationProbe
 *
 * Client component that drops a hydration completion mark and measure.
 * This pairs with the early 'app-init' mark set in instrumentation-client.ts.
 *
 * How it works:
 *   - instrumentation-client.ts calls performance.mark('app-init') before hydration
 *   - This component runs after hydration; we then mark 'hydrated' and measure
 *     duration from 'app-init' to 'hydrated' as 'hydration'.
 *   - Measures are flushed by instrumentation-client.ts when the tab hides/unloads.
 */
export default function MetricsHydrationProbe() {
    useEffect(() => {
        try {
            performance.mark('hydrated')
            performance.measure('hydration', 'app-init', 'hydrated')
        } catch {
            // ignore
        }
    }, [])
    return null
}


